import { render, staticRenderFns } from "./SiteManagement.vue?vue&type=template&id=2c78dc33&"
import script from "./SiteManagement.vue?vue&type=script&lang=js&"
export * from "./SiteManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports